import React from "react";
import "./Breadcrumb.css";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Breadcrumb = ({ pathList, onHomePress }: BreadcrumbProps) => {
  const navigateTo = useNavigate();

  return (
    <Typography className='breadcrumb-typo'>
      {pathList.map((item: BreadcrumbItem, index) => {
        return (
          <React.Fragment key={index.toString()}>
            <span
              className={index === 0 ? "active" : undefined}
              onClick={index === 0 ? onHomePress : () => {
                item.href && navigateTo(item.href);
              }}
              style={{
                cursor: index === 0 ? "pointer" : undefined,
              }}
            >
              {item.label}
              {index !== pathList.length - 1 && <span> / </span>}
            </span>
          </React.Fragment>
        );
      })}
    </Typography>
  );
};

export default Breadcrumb;
